export default {
    methods: {
        //converts js object into laravel array syntax for use in get requests (copied from stack overflow)
        serialiseObjectToLaravelSyntax(obj, prefix) {
            let str = [],
                p

            for (p in obj) {
                if (obj.hasOwnProperty(p)) {
                    var k = prefix ? prefix + "[" + p + "]" : p,
                        v = obj[p]

                    str.push((v !== null && typeof v === "object") ?
                        this.serialiseObjectToLaravelSyntax(v, k) :
                        encodeURIComponent(k) + "=" + encodeURIComponent(v))
                }
            }

            return str.join("&")
        }

    }
}
